
const subCategoryTemplate = () => {
  return `
    <li class="collection-subcategories__item<% if (window.theme.collections.current == sub_categories_json[index].handle) { %> active<% } %>" tabindex="-1" role="menuitem" aria-label="Navigate to: <%= sub_categories_json[index].title %>">
      <a href="<%= sub_categories_json[index].url %>" class="collection-subcategories__cta" tabindex="0">
        <div class="collection-subcategories__circle">
          <img src="<%= sub_categories_json[index].image %>" alt="<%= sub_categories_json[index].title %>" />
        </div>

        <div class="collection-subcategories__title"><%= sub_categories_json[index].title %></div>
      </a>
    </li>
  `;
};

// Bubble sub-categories menu on the PLP pages
export default () => {
  if ($('[data-collection-sub-categories-json]').length === 0) {
    $('[data-collection-subcategories]').remove();
    return false;
  }

  const sub_categories_text = ($('[data-collection-sub-categories-json]').text() === '') ? '[]' : $('[data-collection-sub-categories-json]').text();
  const sub_categories_json = JSON.parse(sub_categories_text);
  // console.log('sub_categories_json', sub_categories_json);

  if (sub_categories_json.length === 0) {
    return false;
  }

  const compiled = _.template(`
    <% jq.each(sub_categories_json, function(index) { %>${subCategoryTemplate()}<% }); %>
    `, {imports: { jq: $ } });
  const sub_categories_html = compiled({ sub_categories_json });

  $('[data-collection-subcategories] ul').append(sub_categories_html);

  $('[data-collection-subcategories] ul').append(`<li class="collection-subcategories__item collection-subcategories__item--last" tabindex="-1" role="menuitem" aria-label="Last">&nbsp;</li>`);
  
  $('[data-collection-subcategories]').addClass('loaded');
};
